import {analytics} from '@cl/shared';
import {DimensionValue} from '../analytics.types';
const {cachedAnalyticsSubject} = analytics;

export default function getDimensionUiDescription(dimension: DimensionValue): string {
  return cachedAnalyticsSubject.data.dimensionUiMetadataMap[dimension]?.description ?? '';
}
